









































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CatatanPaskaSedasiService from "@/services/CatatanPaskaSedasi";
import CatatanPaskaSedasiStore from "@/store/modules/CatatanPaskaSedasiStore";
import http from "@/axios/http-common";

@Component({
  components: { CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardCatatanPaskaSedasi extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ default: false }) readonly isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("catatan_paska_sedasi", "create");
  }

  isEditing = false;
  editId: number | null = null;
  expandedId: number | null = null;
  saving = false;
  ttdDialog = false;
  ttdItem: any = null;

  menuTgl = false;
  menuJam = false;
  formTgl = "";
  formJam = "";

  dokterSearch = "";
  dokterList: any[] = [];
  dokterLoading = false;

  form: any = this.emptyForm();

  keluhanList = [
    { key: "kel_mual_muntah", label: "Mual / Muntah" },
    { key: "kel_pusing", label: "Pusing" },
    { key: "kel_sakit_tenggorokan", label: "Sakit Tenggorokan" },
    { key: "kel_nyeri_dada", label: "Nyeri Dada" },
    { key: "kel_sesak_nafas", label: "Sesak Nafas" },
    { key: "kel_sakit_insersi_lumbal", label: "Sakit Insersi Lumbal" }
  ];

  kesadaranOptions = [
    "Composmentis",
    "Apatis",
    "Somnolen",
    "Sopor",
    "Koma"
  ];

  emptyForm() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tgl_pemeriksaan: "",
      kel_mual_muntah: false,
      kel_pusing: false,
      kel_sakit_tenggorokan: false,
      kel_nyeri_dada: false,
      kel_sesak_nafas: false,
      kel_sakit_insersi_lumbal: false,
      tinggi_badan: null,
      berat_badan: null,
      nafas: null,
      suhu: null,
      nadi: null,
      td_sistol: null,
      td_diastol: null,
      nyeri_kategori: null,
      nyeri_skor: 0,
      kesadaran: null,
      visus: "",
      paru: "",
      jantung: "",
      abdomen: "",
      ekstremitas: "",
      instruksi: [] as string[],
      dokter_anestesi_id: null
    };
  }

  mounted() {
    this.loadData();
    this.loadDokterList();
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val) this.loadData();
  }

  get loading() {
    return CatatanPaskaSedasiStore.loading;
  }

  get dataList() {
    return CatatanPaskaSedasiStore.dataList;
  }

  get stateUser() {
    return userModule.user;
  }

  get sliderColor(): string {
    const skor = this.form.nyeri_skor;
    if (skor === 0) return "green";
    if (skor <= 3) return "yellow darken-2";
    if (skor <= 6) return "orange";
    return "red";
  }

  nyeriChipColor(kategori: string): string {
    switch (kategori) {
      case "tidak_nyeri": return "green";
      case "ringan": return "yellow darken-2";
      case "sedang": return "orange";
      case "berat": return "red";
      default: return "grey";
    }
  }

  nyeriKategoriLabel(kategori: string): string {
    switch (kategori) {
      case "tidak_nyeri": return "Tidak Nyeri";
      case "ringan": return "Nyeri Ringan";
      case "sedang": return "Nyeri Sedang";
      case "berat": return "Nyeri Berat";
      default: return "-";
    }
  }

  countKeluhan(item: any): number {
    return this.keluhanList.filter(k => item[k.key]).length;
  }

  onSkorChange() {
    const skor = this.form.nyeri_skor;
    if (skor === 0) this.form.nyeri_kategori = "tidak_nyeri";
    else if (skor <= 3) this.form.nyeri_kategori = "ringan";
    else if (skor <= 6) this.form.nyeri_kategori = "sedang";
    else this.form.nyeri_kategori = "berat";
  }

  onKategoriChange(val: string) {
    if (val === "tidak_nyeri") this.form.nyeri_skor = 0;
    else if (val === "ringan" && (this.form.nyeri_skor < 1 || this.form.nyeri_skor > 3)) this.form.nyeri_skor = 1;
    else if (val === "sedang" && (this.form.nyeri_skor < 4 || this.form.nyeri_skor > 6)) this.form.nyeri_skor = 4;
    else if (val === "berat" && this.form.nyeri_skor < 7) this.form.nyeri_skor = 7;
  }

  addInstruksi() {
    if (this.form.instruksi.length < 4) {
      this.form.instruksi.push("");
    }
  }

  removeInstruksi(idx: number) {
    this.form.instruksi.splice(idx, 1);
  }

  formatDateTime(dt: string): string {
    if (!dt) return "-";
    return moment(dt).format("DD-MM-YYYY HH:mm");
  }

  toggleExpand(id: number) {
    this.expandedId = this.expandedId === id ? null : id;
  }

  canEdit(item: any): boolean {
    if (this.readOnly) return false;
    return !item.signed_dokter;
  }

  canDelete(item: any): boolean {
    if (this.readOnly) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [{ ditandatangani: item.signed_dokter, penandaTanganId: item.dokter_anestesi_id }],
      userModule.user?.id
    );
  }

  canSignDokter(item: any): boolean {
    if (this.readOnly) return false;
    return !item.signed_dokter && item.dokter_anestesi_id === this.stateUser?.id;
  }

  addNew() {
    this.form = this.emptyForm();
    this.editId = null;
    const now = moment();
    this.formTgl = now.format("YYYY-MM-DD");
    this.formJam = now.format("HH:mm");
    this.isEditing = true;
  }

  startEdit(item: any) {
    this.editId = item.id;
    this.form = {
      register_id: item.register_id,
      pasien_rm: item.pasien_rm,
      tgl_pemeriksaan: item.tgl_pemeriksaan,
      kel_mual_muntah: item.kel_mual_muntah || false,
      kel_pusing: item.kel_pusing || false,
      kel_sakit_tenggorokan: item.kel_sakit_tenggorokan || false,
      kel_nyeri_dada: item.kel_nyeri_dada || false,
      kel_sesak_nafas: item.kel_sesak_nafas || false,
      kel_sakit_insersi_lumbal: item.kel_sakit_insersi_lumbal || false,
      tinggi_badan: item.tinggi_badan,
      berat_badan: item.berat_badan,
      nafas: item.nafas,
      suhu: item.suhu,
      nadi: item.nadi,
      td_sistol: item.td_sistol,
      td_diastol: item.td_diastol,
      nyeri_kategori: item.nyeri_kategori,
      nyeri_skor: item.nyeri_skor ?? 0,
      kesadaran: item.kesadaran,
      visus: item.visus || "",
      paru: item.paru || "",
      jantung: item.jantung || "",
      abdomen: item.abdomen || "",
      ekstremitas: item.ekstremitas || "",
      instruksi: item.instruksi ? [...item.instruksi] : [],
      dokter_anestesi_id: item.dokter_anestesi_id
    };
    const dt = moment(item.tgl_pemeriksaan);
    this.formTgl = dt.format("YYYY-MM-DD");
    this.formJam = dt.format("HH:mm");

    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
    this.editId = null;
  }

  async save() {
    if (!this.formTgl || !this.formJam) {
      appModule.NoticeDelay("Tanggal dan jam pemeriksaan harus diisi");
      return;
    }
    if (!this.form.dokter_anestesi_id) {
      appModule.NoticeDelay("Dokter Anestesi harus dipilih");
      return;
    }

    this.form.tgl_pemeriksaan = `${this.formTgl} ${this.formJam}:00`;
    this.form.register_id = this.register;
    this.form.pasien_rm = this.rm;

    // Filter empty instruksi
    this.form.instruksi = this.form.instruksi.filter((s: string) => s.trim() !== "");

    this.saving = true;
    try {
      if (this.editId) {
        await CatatanPaskaSedasiService.update(this.editId, this.form);
        appModule.NoticeDelay("Berhasil mengubah Catatan Paska Anestesi");
      } else {
        await CatatanPaskaSedasiService.create(this.form);
        appModule.NoticeDelay("Berhasil menyimpan Catatan Paska Anestesi");
      }
      this.isEditing = false;
      this.editId = null;
      this.loadData();
    } catch (e) {
      // ErrorAlert handled in service
    } finally {
      this.saving = false;
    }
  }

  async remove(item: any) {
    if (!this.canDelete(item)) return;
    const conf = confirmRemove("Catatan Paska Anestesi");
    if (!conf) return;

    try {
      const resp = await CatatanPaskaSedasiService.destroy(item.id);
      if (resp.status == 1) {
        appModule.NoticeDelay("Berhasil menghapus Catatan Paska Anestesi");
        this.loadData();
      }
    } catch (e) {
      // ErrorAlert handled in service
    }
  }

  cetakPdf(id: number) {
    CatatanPaskaSedasiService.print(id);
  }

  openTtd(item: any) {
    this.ttdItem = item;
    this.ttdDialog = true;
  }

  async confirmTtd(password: string) {
    if (!this.ttdItem) return;

    try {
      const resp = await CatatanPaskaSedasiService.signDokter(this.ttdItem.id, { password });
      if (resp.status == 1) {
        appModule.NoticeDelay("Berhasil menandatangani");
        this.ttdDialog = false;
        this.ttdItem = null;
        this.loadData();
      }
    } catch (e) {
      // ErrorAlert handled in service
    }
  }

  async loadData() {
    await CatatanPaskaSedasiStore.getByRegister(this.register);
  }

  reload() {
    this.loadData();
  }

  async loadDokterList() {
    this.dokterLoading = true;
    try {
      const res = await http.getData("/combo/dokter");
      this.dokterList = (res.data || []).map((d: any) => ({ id: d.user_id, nama: d.nama }));
    } catch {
      this.dokterList = [];
    }
    this.dokterLoading = false;
  }
}
